import '../styles/source-code.css';

class SourceCode {
  modalActive = false;

  constructor(quill, options = {}) {
    const { userType } = options;

    this.quill = quill;
    this.options = options;
    this.editorContainerId = `#${this.quill.container.id}-container`;

    if (userType === 'ADMIN' || userType === 'SUPPORT') {
      this.renderElements();
      this.renderToolbarIcon();

      return;
    }

    document.querySelector(`${this.editorContainerId} .ql-source-code`).classList.add('hidden');
  }

  renderElements() {
    this.sourceCodeBtnEl = document.querySelector(`${this.editorContainerId} .ql-source-code`);
    this.sourceCodeBtnEl.addEventListener('click', this.openModal.bind(this));
  }

  getElRefs() {
    this.modalEl = document.querySelector('.ql-modal.source-code');
    this.closeEl = this.modalEl.querySelector('.ql-modal-close');
    this.dialogEl = this.modalEl.querySelector('.ql-modal-dialog');
    this.sourceEl = this.modalEl.querySelector('.ql-modal-source');
    this.cancelEl = this.modalEl.querySelector('.ql-modal-cancel');
    this.saveEl = this.modalEl.querySelector('.ql-modal-save');
  }

  bindEvents() {
    this.saveEl.addEventListener('click', this.saveSource.bind(this));
    this.closeEl.addEventListener('click', this.closeModal.bind(this));
    this.cancelEl.addEventListener('click', this.closeModal.bind(this));
    this.modalEl.addEventListener('click', this.closeModal.bind(this));
    this.dialogEl.addEventListener('click', e => e.stopPropagation());
  }

  fillTextarea() {
    const editorContent = this.quill.root.innerHTML;
    this.sourceEl.value = editorContent;
  }

  saveSource() {
    this.quill.root.innerHTML = this.sourceEl.value.replace(/\r?\n|\r/g, '');
    this.closeModal();
  }

  openModal() {
    this.renderModal();
    this.getElRefs();
    this.bindEvents();

    setTimeout(() => {
      this.fillTextarea();
      document.body.setAttribute('data-state', 'modalActive');
      this.backdropEl.setAttribute('data-state', 'open');
      this.modalEl.setAttribute('data-state', 'open');
      this.modalActive = true;
      this.dialogEl.focus();
    }, 50);
  }

  removeModal() {
    this.modalEl?.remove();
    this.closeEl?.remove();
    this.dialogEl?.remove();
    this.sourceEl?.remove();
    this.cancelEl?.remove();
    this.saveEl?.remove();
  }

  closeModal() {
    document.body.removeAttribute('data-state');
    this.backdropEl.setAttribute('data-state', 'closed');
    this.modalEl.setAttribute('data-state', 'closed');
    this.modalActive = false;
    this.removeModal();
  }

  renderModal() {
    this.modalEl = this.createModalEl('div', ['ql-modal', 'source-code'], document.body);
    this.modalEl.setAttribute('data-state', 'closed');
    const dialogEl = this.createModalEl('div', 'ql-modal-dialog', this.modalEl);
    dialogEl.setAttribute('tabindex', 1);
    const contentEl = this.createModalEl('div', 'ql-modal-content', dialogEl);
    contentEl.innerHTML = this.getModalContentTemplate();
    this.backdropEl = this.createModalEl('div', 'ql-modal-backdrop', document.body);
    this.backdropEl.setAttribute('data-state', 'closed');
  }

  createModalEl(elType, classNames, containerEl) {
    const el = document.createElement(elType);
    if (Array.isArray(classNames)) {
      classNames.forEach(className => el.classList.add(className));
    } else {
      el.classList.add(classNames);
    }
    containerEl.appendChild(el);

    return el;
  }

  renderToolbarIcon() {
    this.sourceCodeBtnEl.innerHTML = '&lt; source &gt;';
  }

  getModalContentTemplate() {
    return `
      <div class="ql-modal-header">
        <h5 class="ql-modal-title">Source Code</h5>
        <button class="ql-modal-close"></button>
      </div>
      <div class="ql-modal-body">
        <textarea class="ql-modal-source" contenteditable="true"></textarea>
      </div>
      <div class="ql-modal-footer">
        <button class="ql-modal-btn ql-modal-btn-primary ql-modal-save" type="button">Save</button>
        <button class="ql-modal-btn ql-modal-btn-secondary ql-modal-cancel" type="button">Cancel</button>
      </div>`;
  }
}

export default SourceCode;
